import axios from "axios";

export const getProductLists = async (body) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/productListManagement/getProductLists",
      body
    );

    if (status === 200 && data.success === true) return data.result;
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const getProductList = async (body) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/productListManagement/getProductList",
      body
    );

    if (status === 200 && data.success === true) return data.result;
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const deleteProductList = async (body) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/productListManagement/deleteProductList",
      body
    );

    if (status === 200 && data.success === true) return data.result;
  } catch (error) {
    console.error(error);
  }
  return null;
};


export const updateProductList = async (body) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/productListManagement/updateProductList",
      body
    );

    if (status === 200 && data.success === true) return data.result;
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const createProductList = async (body) => {
  try {
    const { status, data } = await axios.post(
      "/api/v1/productListManagement/createProductList",
      body
    );

    if (status === 200 && data.success === true) return data.result;
  } catch (error) {
    console.error(error);
  }
  return null;
};